import { useState } from 'react'
import { LockKeyhole, CheckCircle } from 'lucide-react'
import { capture } from '../services/posthog'

interface Props {
  onClose: () => void
}

export default function PlanLimitModal({ onClose }: Props) {
  const [interested, setInterested] = useState(false)

  function handleUpgrade() {
    capture('upgrade_interest_clicked', { source: 'plan_limit_modal' })
    setInterested(true)
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />

      <div className="relative bg-white rounded-2xl shadow-xl w-full max-w-sm flex flex-col">
        <div className="px-6 pt-6 pb-4 text-center">
          {interested ? (
            <>
              <div className="flex justify-center mb-3"><CheckCircle size={36} className="text-green-500" /></div>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">Grazie per il tuo interesse!</h2>
              <p className="text-sm text-gray-500">
                Ti avviseremo via email non appena i piani a pagamento saranno disponibili.
              </p>
            </>
          ) : (
            <>
              <div className="flex justify-center mb-3"><LockKeyhole size={36} className="text-sky-400" /></div>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">Limite raggiunto</h2>
              <p className="text-sm text-gray-500">
                Hai raggiunto il numero massimo di avvisi per il piano gratuito.
                Con il piano Pro puoi gestire fino a 10 avvisi a partire da €4/mese.
              </p>
            </>
          )}
        </div>

        <div className="flex flex-col gap-2 px-6 pb-6">
          {interested ? (
            <button
              onClick={onClose}
              className="w-full bg-sky-600 hover:bg-sky-700 text-white text-sm font-medium rounded-lg px-4 py-2.5 transition-colors"
            >
              Chiudi
            </button>
          ) : (
            <>
              <button
                onClick={handleUpgrade}
                className="w-full bg-sky-600 hover:bg-sky-700 text-white text-sm font-medium rounded-lg px-4 py-2.5 transition-colors"
              >
                Sono interessato — avvisami
              </button>
              <button
                onClick={onClose}
                className="w-full text-sm font-medium text-gray-600 hover:text-gray-900 px-4 py-2.5 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors"
              >
                Torna indietro
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
